import { render, staticRenderFns } from "./seguimientoCuentas.vue?vue&type=template&id=c83239b8"
import script from "./seguimientoCuentas.vue?vue&type=script&lang=js"
export * from "./seguimientoCuentas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports